import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { change, Field } from 'redux-form';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import ItinerarySearchInput from '../../../../common/forms/input/ItinerarySearchInput';
import FormFooter from '../../../../common/forms/FormFooter';
import { BAGGAGE_MANIFEST_ACTIONS } from '../../../../../config/constants';
import Select from '../../../../common/forms/select/Select';
import { isRequired } from '../../../../../utils/validators';
import TextInput from '../../../../common/forms/input/TextInput';
import { BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT } from '../../../../../config/endpoints';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { WRITE } from '../../../../../config/permissions';

const BaggageManifestChangeSection = ({
  form,
  dispatchChange,
  saveButtonDisabled,
}) => {
  const handleSelectNewItinerary = ({ itineraryId }) => {
    dispatchChange(form, 'newItineraryId', itineraryId);
  };

  const handleClearNewItinerary = () => {
    dispatchChange(form, 'newItineraryId', null);
  };

  return (
    <>
      <FormGroup row>
        <FormItem label="Acción" required>
          <Field
            name="action"
            component={Select}
            options={[BAGGAGE_MANIFEST_ACTIONS.CHANGE_ITINERARY]}
            validate={[isRequired]}
            isDisabled
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Nuevo Itinerario" required>
          <Field
            name="newItinerary"
            component={ItinerarySearchInput}
            placeholder="Itinerario"
            handleSelectItinerary={handleSelectNewItinerary}
            handleClear={handleClearNewItinerary}
            props={{ form }}
          />
          <Field name="newItineraryId" component="input" type="hidden" />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Comentario" required>
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Comentario"
          />
        </FormItem>
      </FormGroup>
      <FormFooter saveButtonDisabled={saveButtonDisabled} />
    </>
  );
};

BaggageManifestChangeSection.propTypes = {
  form: PropTypes.string.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  // eslint-disable-next-line
  isManifestPrinted: PropTypes.bool.isRequired,
  saveButtonDisabled: PropTypes.bool,
};

BaggageManifestChangeSection.defaultProps = {
  saveButtonDisabled: false,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const ConnectedBaggageManifestChangeSection = connect(
  null,
  mapDispatchToProps,
)(BaggageManifestChangeSection);

export default withEndpointAuthorization({
  url: BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT,
  permissionType: WRITE,
  showForAllWhen: (props) => !props.isManifestPrinted,
})(ConnectedBaggageManifestChangeSection);
